import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import ImageUploadModal from 'components/common/ImageUploadModal';
import { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { UseControllerProps, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type ImageUploadControlProps = UseControllerProps<any> & {
  minWidth: number;
  minHeight: number;
  maxWidth: number;
  maxHeight: number;
  maxFileSize: number; //MB
};

function ImageUploadControl(props: ImageUploadControlProps) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const { minWidth, minHeight, maxWidth, maxHeight, maxFileSize } = props;
  const { field } = useController(props);

  //ref
  const imageElemRef = useRef<HTMLImageElement>(null);

  function handleUploadImage({
    imagepath,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    maxFileSize,
  }: {
    imagepath: string;
    minWidth: number;
    minHeight: number;
    maxWidth: number;
    maxHeight: number;
    maxFileSize: number;
  }) {
    showGlobalModal(() => (
      <ImageUploadModal
        minWidth={minWidth}
        minHeight={minHeight}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        maxFileSize={maxFileSize}
        imagepath={imagepath}
        onReflect={(filename: string) => {
          field.onChange(filename);
        }}
      />
    ));
  }

  return (
    <div className="d-flex gap-3 justify-content-between">
      <div className="position-relative d-inline-block">
        {field.value && field.value.length > 0 && (
          <img
            ref={imageElemRef}
            src={process.env.REACT_APP_IMAGE_URL + field.value}
            alt=""
            style={{ maxHeight: '240px' }}
          />
        )}
      </div>
      <div className="d-flex align-items-end">
        <Button
          className="d-inline-block"
          onClick={handleUploadImage.bind(null, {
            imagepath: field.value && field.value.length > 0 ? process.env.REACT_APP_IMAGE_URL + field.value : '',
            minWidth: minWidth,
            minHeight: minHeight,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            maxFileSize: maxFileSize,
          })}
        >
          {t('App.change')}
        </Button>
      </div>
    </div>
  );
}

export default ImageUploadControl;
